import { Component, OnInit } from '@angular/core';
import { expand } from 'rxjs/operators';
import { BaseService } from 'src/app/shared/services/base.service';
import { BaseDynamicTemplate } from '../modal-confirmation.component';

@Component({
  selector: 'app-export-confirmation',
  templateUrl: './export-confirmation.component.html',
  styleUrls: ['./export-confirmation.component.scss'],
})
export class ExportConfirmationComponent extends BaseDynamicTemplate<any> {}
